import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.4752 11.1818C10.6704 11.3771 10.987 11.3771 11.1823 11.1818C11.3776 10.9865 11.3776 10.67 11.1823 10.4747L8.70743 7.99983L11.1823 5.52497C11.3775 5.32971 11.3775 5.01312 11.1823 4.81786C10.987 4.6226 10.6704 4.6226 10.4752 4.81786L8.00032 7.29272L5.52543 4.81783C5.33017 4.62257 5.01359 4.62257 4.81833 4.81783C4.62307 5.0131 4.62307 5.32968 4.81833 5.52494L7.29321 7.99983L4.81832 10.4747C4.62306 10.67 4.62306 10.9866 4.81832 11.1818C5.01358 11.3771 5.33017 11.3771 5.52543 11.1818L8.00032 8.70693L10.4752 11.1818Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgXCircle);
export default ForwardRef;
